import { render, staticRenderFns } from "./DocumentList.component.vue?vue&type=template&id=6bfca0c8"
import script from "./DocumentList.component.vue?vue&type=script&lang=js"
export * from "./DocumentList.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports